import type { typeSelectItem } from "@sportsmet/ui";

export const QUIET_HOURS_STEP_MINUTES = 30;
export const QUIET_HOURS_DEFAULT_START_MINUTE = 1320;
export const QUIET_HOURS_DEFAULT_END_MINUTE = 480;

const QUIET_HOURS_MINUTES_IN_DAY = 1440;

export function formatQuietHoursMinute({ minute }: { minute: number }): string {
  const hour24 = Math.floor(minute / 60);
  const mins = minute % 60;
  const period = hour24 < 12 ? "AM" : "PM";
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  const minuteText = mins.toString().padStart(2, "0");
  return `${hour12}:${minuteText} ${period}`;
}

export function buildQuietHoursTimeOptions(): readonly typeSelectItem[] {
  const items: typeSelectItem[] = [];
  for (
    let minute = 0;
    minute < QUIET_HOURS_MINUTES_IN_DAY;
    minute += QUIET_HOURS_STEP_MINUTES
  ) {
    items.push({
      value: String(minute),
      label: formatQuietHoursMinute({ minute }),
    });
  }
  return items;
}

export function parseQuietHoursOptionValue({
  value,
}: {
  value: string;
}): number | null {
  const parsed = Number.parseInt(value, 10);
  if (!Number.isInteger(parsed)) {
    return null;
  }
  if (
    parsed < 0 ||
    parsed >= QUIET_HOURS_MINUTES_IN_DAY ||
    parsed % QUIET_HOURS_STEP_MINUTES !== 0
  ) {
    return null;
  }
  return parsed;
}
